import { AddressSchema } from '@onepercentio/rarum-types/_shared'
import { Address } from 'features/Form/AddressForm/AddressForm.types'
import Text from 'openspace/components/Text'

export function AddressContent({
  address: add,
}: {
  address: Pick<Address, keyof AddressSchema>
}) {
  return (
    <div>
      <Text type='h6'>{add.street}</Text>
      <Text type='h6'>{add.number}</Text>
      {add.complement && <Text type='h6'>{add.complement}</Text>}
      <Text type='h6'>{add.neighborhood}</Text>
      <Text type='h6'>
        {add.city}, {add.state}
      </Text>
      <Text type='h6'>{add.zipCode}</Text>
    </div>
  )
}
